var _g, _g2, _g3, _g4, _g5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolidObject3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 900,
    viewBox: "0 0 1440 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_1040_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.105 450C879.105 759.831 950.995 1073.41 1088.6 1073.41C1152.55 1073.41 1206.58 1005.49 1244.95 876.928C1279.35 762.478 1298.09 610.76 1298.09 450C1298.09 140.169 1226.2 -173.411 1088.6 -173.411C1024.65 -173.411 970.621 -105.49 932.251 23.073C897.849 137.744 879.105 289.241 879.105 450ZM1231.94 450C1231.94 604.585 1214.08 749.467 1181.66 857.963C1166.66 908.021 1149.02 948.376 1130.28 974.839C1115.5 995.788 1100.73 1007.26 1088.6 1007.26C1064.56 1007.26 1026.41 961.166 995.54 857.963C963.123 749.467 945.261 604.585 945.261 450C945.261 295.415 963.123 150.534 995.54 42.0376C1010.54 -8.02052 1028.18 -48.3757 1046.92 -74.8381C1061.7 -95.7876 1076.47 -107.255 1088.6 -107.255C1112.64 -107.255 1150.79 -61.1659 1181.66 42.0376C1214.08 150.754 1231.94 295.636 1231.94 450Z",
    fill: "url(#paint0_radial_1040_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M879.105 450C879.105 759.831 950.995 1073.41 1088.6 1073.41C1152.55 1073.41 1206.58 1005.49 1244.95 876.928C1279.35 762.478 1298.09 610.76 1298.09 450C1298.09 140.169 1226.2 -173.411 1088.6 -173.411C1024.65 -173.411 970.621 -105.49 932.251 23.073C897.849 137.744 879.105 289.241 879.105 450ZM1231.94 450C1231.94 604.585 1214.08 749.467 1181.66 857.963C1166.66 908.021 1149.02 948.376 1130.28 974.839C1115.5 995.788 1100.73 1007.26 1088.6 1007.26C1064.56 1007.26 1026.41 961.166 995.54 857.963C963.123 749.467 945.261 604.585 945.261 450C945.261 295.415 963.123 150.534 995.54 42.0376C1010.54 -8.02052 1028.18 -48.3757 1046.92 -74.8381C1061.7 -95.7876 1076.47 -107.255 1088.6 -107.255C1112.64 -107.255 1150.79 -61.1659 1181.66 42.0376C1214.08 150.754 1231.94 295.636 1231.94 450Z",
    fill: "#39FF1B",
    fillOpacity: 0.38
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8,
    filter: "url(#filter1_ii_1040_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M670.493 450C670.493 583.856 686.15 710.435 714.817 805.92C737.531 882.22 779.65 973.074 849.996 973.074C920.563 973.074 962.462 882.22 985.175 805.92C1013.62 710.435 1029.5 584.076 1029.5 450C1029.5 315.924 1013.84 189.566 985.175 94.0803C962.462 17.7803 920.342 -73.0742 849.996 -73.0742C779.43 -73.0742 737.531 17.7803 714.818 94.0802C686.37 189.786 670.493 316.144 670.493 450ZM963.344 450C963.344 577.681 948.569 697.424 921.886 786.955C893.659 881.779 862.566 906.918 849.996 906.918C837.427 906.918 806.554 881.779 778.107 786.955C751.424 697.424 736.649 577.681 736.649 450C736.649 322.319 751.424 202.576 778.107 113.045C806.554 18.2213 837.427 -6.91804 849.996 -6.91804C862.566 -6.91804 893.439 18.2213 921.886 113.045C948.569 202.797 963.344 322.319 963.344 450Z",
    fill: "url(#paint1_radial_1040_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M670.493 450C670.493 583.856 686.15 710.435 714.817 805.92C737.531 882.22 779.65 973.074 849.996 973.074C920.563 973.074 962.462 882.22 985.175 805.92C1013.62 710.435 1029.5 584.076 1029.5 450C1029.5 315.924 1013.84 189.566 985.175 94.0803C962.462 17.7803 920.342 -73.0742 849.996 -73.0742C779.43 -73.0742 737.531 17.7803 714.818 94.0802C686.37 189.786 670.493 316.144 670.493 450ZM963.344 450C963.344 577.681 948.569 697.424 921.886 786.955C893.659 881.779 862.566 906.918 849.996 906.918C837.427 906.918 806.554 881.779 778.107 786.955C751.424 697.424 736.649 577.681 736.649 450C736.649 322.319 751.424 202.576 778.107 113.045C806.554 18.2213 837.427 -6.91804 849.996 -6.91804C862.566 -6.91804 893.439 18.2213 921.886 113.045C948.569 202.797 963.344 322.319 963.344 450Z",
    fill: "#39FF1B",
    fillOpacity: 0.38
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter2_ii_1040_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M462.101 450C462.101 653.54 508.851 872.517 611.614 872.517C714.376 872.517 761.126 653.54 761.126 450C761.126 246.459 714.376 27.4828 611.614 27.4828C508.851 27.4828 462.101 246.68 462.101 450ZM694.75 450C694.75 550.998 683.062 645.381 662.113 715.947C639.84 790.263 616.245 806.361 611.614 806.361C606.983 806.361 583.167 790.263 561.115 715.947C539.945 645.381 528.478 550.998 528.478 450C528.478 349.001 540.165 254.619 561.115 184.052C583.387 109.737 606.983 93.6389 611.614 93.6389C616.245 93.6389 640.061 109.737 662.113 184.052C683.062 254.839 694.75 349.222 694.75 450Z",
    fill: "url(#paint2_radial_1040_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M462.101 450C462.101 653.54 508.851 872.517 611.614 872.517C714.376 872.517 761.126 653.54 761.126 450C761.126 246.459 714.376 27.4828 611.614 27.4828C508.851 27.4828 462.101 246.68 462.101 450ZM694.75 450C694.75 550.998 683.062 645.381 662.113 715.947C639.84 790.263 616.245 806.361 611.614 806.361C606.983 806.361 583.167 790.263 561.115 715.947C539.945 645.381 528.478 550.998 528.478 450C528.478 349.001 540.165 254.619 561.115 184.052C583.387 109.737 606.983 93.6389 611.614 93.6389C616.245 93.6389 640.061 109.737 662.113 184.052C683.062 254.839 694.75 349.222 694.75 450Z",
    fill: "#39FF1B",
    fillOpacity: 0.38
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4,
    filter: "url(#filter3_ii_1040_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M253.489 449.999C253.489 530.269 262.972 606.348 280.172 663.904C301.563 735.794 332.876 772.18 373.011 772.18C413.146 772.18 444.239 735.794 465.85 663.904C483.051 606.348 492.533 530.489 492.533 449.999C492.533 369.51 483.051 293.651 465.85 236.095C444.46 164.205 413.146 127.819 373.011 127.819C332.877 127.819 301.783 164.205 280.172 236.095C262.972 293.871 253.489 369.73 253.489 449.999ZM373.011 704.921C366.837 699.628 352.723 680.223 340.154 632.59C326.922 582.532 319.645 517.699 319.645 449.999C319.645 382.3 326.922 317.467 340.154 267.409C352.723 219.776 366.837 200.37 373.011 195.078C379.186 200.37 393.299 219.776 405.869 267.409C419.1 317.467 426.377 382.3 426.377 449.999C426.377 517.699 419.1 582.532 405.869 632.59C393.079 680.223 379.186 699.849 373.011 704.921Z",
    fill: "url(#paint3_radial_1040_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.489 449.999C253.489 530.269 262.972 606.348 280.172 663.904C301.563 735.794 332.876 772.18 373.011 772.18C413.146 772.18 444.239 735.794 465.85 663.904C483.051 606.348 492.533 530.489 492.533 449.999C492.533 369.51 483.051 293.651 465.85 236.095C444.46 164.205 413.146 127.819 373.011 127.819C332.877 127.819 301.783 164.205 280.172 236.095C262.972 293.871 253.489 369.73 253.489 449.999ZM373.011 704.921C366.837 699.628 352.723 680.223 340.154 632.59C326.922 582.532 319.645 517.699 319.645 449.999C319.645 382.3 326.922 317.467 340.154 267.409C352.723 219.776 366.837 200.37 373.011 195.078C379.186 200.37 393.299 219.776 405.869 267.409C419.1 317.467 426.377 382.3 426.377 449.999C426.377 517.699 419.1 582.532 405.869 632.59C393.079 680.223 379.186 699.849 373.011 704.921Z",
    fill: "#39FF1B",
    fillOpacity: 0.38
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2,
    filter: "url(#filter4_ii_1040_1344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M141.905 450C141.905 503.586 148.3 554.085 159.767 592.897C175.424 645.16 199.461 671.623 231.216 671.623C262.971 671.623 287.228 645.16 302.665 592.897C314.132 554.306 320.527 503.586 320.527 450C320.527 396.413 314.132 345.914 302.665 307.102C287.008 254.839 262.971 228.377 231.216 228.377C199.461 228.377 175.204 254.839 159.768 307.102C148.3 345.914 141.905 396.634 141.905 450ZM231.437 596.205C220.852 573.932 208.061 523.212 208.061 450C208.061 376.787 220.852 326.067 231.437 303.795C242.022 326.067 254.812 376.787 254.812 450C254.812 523.212 241.801 573.932 231.437 596.205Z",
    fill: "url(#paint4_radial_1040_1344)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.905 450C141.905 503.586 148.3 554.085 159.767 592.897C175.424 645.16 199.461 671.623 231.216 671.623C262.971 671.623 287.228 645.16 302.665 592.897C314.132 554.306 320.527 503.586 320.527 450C320.527 396.413 314.132 345.914 302.665 307.102C287.008 254.839 262.971 228.377 231.216 228.377C199.461 228.377 175.204 254.839 159.768 307.102C148.3 345.914 141.905 396.634 141.905 450ZM231.437 596.205C220.852 573.932 208.061 523.212 208.061 450C208.061 376.787 220.852 326.067 231.437 303.795C242.022 326.067 254.812 376.787 254.812 450C254.812 523.212 241.801 573.932 231.437 596.205Z",
    fill: "#39FF1B",
    fillOpacity: 0.38
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_1040_1344",
    x: 841.505,
    y: -173.411,
    width: 510.576,
    height: 1312.62,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.6004,
    dy: 65.8006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.9008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 53.987,
    dy: 31.4924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_1344",
    result: "effect2_innerShadow_1040_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_1040_1344",
    x: 632.892,
    y: -73.0742,
    width: 450.595,
    height: 1111.95,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.6004,
    dy: 65.8006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.9008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 53.987,
    dy: 31.4924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_1344",
    result: "effect2_innerShadow_1040_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_1040_1344",
    x: 424.501,
    y: 27.4829,
    width: 390.613,
    height: 910.834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.6004,
    dy: 65.8006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.9008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 53.987,
    dy: 31.4924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_1344",
    result: "effect2_innerShadow_1040_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_1040_1344",
    x: 215.889,
    y: 127.819,
    width: 330.631,
    height: 710.161,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.6004,
    dy: 65.8006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.9008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 53.987,
    dy: 31.4924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_1344",
    result: "effect2_innerShadow_1040_1344"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_1040_1344",
    x: 104.305,
    y: 228.376,
    width: 270.209,
    height: 509.047,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -37.6004,
    dy: 65.8006
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 79.9008
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.87 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "lighten",
    in2: "shape",
    result: "effect1_innerShadow_1040_1344"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 53.987,
    dy: 31.4924
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 31.4924
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.168627 0 0 0 0 0.180392 0 0 0 0 0.239216 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "effect1_innerShadow_1040_1344",
    result: "effect2_innerShadow_1040_1344"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1040_1344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-149.231 -21.6225 -282.141 1116.35 1332.29 650.89)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1040_1344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-127.868 -18.1424 -241.75 936.678 1058.8 618.557)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1040_1344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-106.504 -14.6546 -201.359 756.608 785.532 586.153)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1040_1344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-85.1404 -11.1745 -160.969 576.934 512.043 553.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1040_1344",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(-63.6196 -7.6868 -120.281 396.864 335.105 521.416)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#949494"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.635171,
    stopColor: "#181818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D1D1D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidObject3);
export default __webpack_public_path__ + "static/media/SolidObject-3.4d67e47ae3ec09dd955f2f654f11ea03.svg";
export { ForwardRef as ReactComponent };